<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Manage automated workflows for action management. Configure rules that trigger automatically based on specific conditions.
    </p>
    <div class="adf-hero-stats" *ngIf="isConfigurationReady">
      <div class="adf-stat">
        <span class="adf-stat-value">{{ pagination.statusRulesCount || filteredWorkflows.length || 0 }}</span>
        <span class="adf-stat-label">Workflows</span>
      </div>
    </div>
  </div>

  <div class="adf-loader" *ngIf="!isConfigurationReady">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <div class="adf-content" *ngIf="isConfigurationReady">
    <div class="adf-control-bar">
      <div class="adf-control-bar-main">
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="addNewWorkflow()">
          New Workflow
        </button>
      </div>

      <div class="adf-control-bar-tools">
        <div class="adf-search">
          <span class="adf-search-icon" aria-hidden="true">
            <svg class="icon-set">
              <use [attr.xlink:href]="'./assets/images/icons.svg#search'"></use>
            </svg>
          </span>
          <input type="text" class="adf-search-input" placeholder="Search workflows…"
            [(ngModel)]="searchText" (input)="onSearchChange()" (keyup)="onSearchChange()"
            [disabled]="!completeWorkflow || completeWorkflow.length === 0">
        </div>

        <div class="adf-paging">
          <button type="button" [disabled]="!pagingButtons.isFirst" (click)="paginateWorkflowsList('first')" title="First">
            <img src="assets/images/chevron-double-left.svg" alt="" />
          </button>
          <button type="button" [disabled]="!pagingButtons.isPrevious" (click)="paginateWorkflowsList('previous')" title="Previous">
            <img src="assets/images/chevron-left.svg" alt="" />
          </button>
          <span [class.disabled]="pagination.statusRulesCount <= 0">
            {{ pagination.statusRulesPageFrom }}–{{ pagination.statusRulesPageTo }} / {{ pagination.statusRulesCount }}
          </span>
          <button type="button" [disabled]="!pagingButtons.isNext" (click)="paginateWorkflowsList('next')" title="Next">
            <img src="assets/images/chevron-right.svg" alt="" />
          </button>
          <button type="button" [disabled]="!pagingButtons.isLast" (click)="paginateWorkflowsList('last')" title="Last">
            <img src="assets/images/chevron-double-right.svg" alt="" />
          </button>
        </div>
      </div>
    </div>

    <div class="adf-rules">
      <div class="adf-rules-list" *ngIf="filteredWorkflows.length">
        <div class="adf-rule-card" *ngFor="let workflow of filteredWorkflows">
          <div class="adf-rule-main">
            <div class="adf-rule-title-row">
              <h4 class="adf-rule-name">{{ workflow.name }}</h4>
              <span class="adf-status-pill" [class.is-on]="workflow.active" [class.is-off]="!workflow.active">
                {{ workflow.active ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="adf-rule-meta">
              <span class="adf-rule-meta-text">Created : {{ workflow.formatted_created_date || (workflow.createdDate | date:'dd-MMM-yy HH:mm') }}</span>
              <span class="adf-meta-dot" aria-hidden="true"></span>
              <span class="adf-rule-meta-text">Updated : {{ workflow.last_updated_by || (workflow.lastUpdated | date:'dd-MMM-yy HH:mm') }}</span>
            </div>
          </div>
          <div class="adf-rule-side">
            <label class="adf-switch" title="Toggle active">
              <input type="checkbox" [disabled]="readonly" [checked]="workflow.active" (change)="toggleWorkflow(workflow)">
              <span class="adf-switch-slider"></span>
            </label>
            <button type="button" class="adf-icon-btn" (click)="editWorkflow(workflow)" title="Edit workflow">
              <svg class="icon-set">
                <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
              </svg>
            </button>
            <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteWorkflow(workflow)" title="Delete workflow">
              <svg class="icon-set">
                <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="adf-empty" *ngIf="!filteredWorkflows.length">
        <div class="adf-empty-visual adf-empty-visual--rules" aria-hidden="true">
          <span></span><span></span>
        </div>
        <div class="adf-empty-title">No workflows yet</div>
        <div class="adf-empty-text">Create a workflow to automate actions based on conditions.</div>
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="addNewWorkflow()">
          New Workflow
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()"></div>
  <aside class="right-modal" *ngIf="isModalOpen" [class.open]="isModalOpen" aria-modal="true" role="dialog">
    <dynamic-action-form-renderer [readonly]="readonly" [schema]="modalSchema" [data]="defaultValues" (close)="closeModal()"
      (submit)="onFormSubmit($event)">
    </dynamic-action-form-renderer>
  </aside>
</div>
